import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { getListingWithPrivateData } from '../../util/api';
import { loadCompanyCredentialDetails } from '../../ducks/user.duck';

import { types as sdkTypes } from '../../util/sdkLoader';
import { userTypeOf } from '../../util/userType';
const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SHOW_PROFILE_LISTING_REQUEST = 'app/PersonaVerification/SHOW_PROFILE_LISTING_REQUEST';
export const SHOW_PROFILE_LISTING_SUCCESS = 'app/PersonaVerification/SHOW_PROFILE_LISTING_SUCCESS';
export const SHOW_PROFILE_LISTING_ERROR = 'app/PersonaVerification/SHOW_PROFILE_LISTING_ERROR';

// ================ Reducer ================ //

const initialState = {
  profileListing: null,
  profileListingError: null,
  profileListingLoading: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SHOW_PROFILE_LISTING_REQUEST:
      return {
        ...state,
        profileListingLoading: true,
        profileListingError: null,
      };
    case SHOW_PROFILE_LISTING_SUCCESS:
      return {
        ...state,
        profileListing: payload,
        profileListingLoading: false,
      };
    case SHOW_PROFILE_LISTING_ERROR:
      return {
        ...state,
        profileListingError: payload,
        profileListingLoading: false,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const showProfileListingRequest = params => ({
  type: SHOW_PROFILE_LISTING_REQUEST,
  payload: { params },
});
export const showProfileListingSuccess = result => ({
  type: SHOW_PROFILE_LISTING_SUCCESS,
  payload: result,
});
export const showProfileListingError = error => ({
  type: SHOW_PROFILE_LISTING_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

export const showProfileListing = () => async (dispatch, getState, sdk) => {
  dispatch(showProfileListingRequest());

  const state = getState();
  const { currentUser } = state.user;

  const profileListingId =
    currentUser?.attributes?.profile?.publicData?.profileListingId ||
    currentUser?.attributes?.profile?.publicData?.firstListingId;

  if (profileListingId === undefined) {
    return null;
  }

  return getListingWithPrivateData({
    listingId: profileListingId,
    // Private data carries which Persona inquiry verified each document.
    responseFields: ['title', 'publicData', 'privateData'],
  })
    .then(async response => {
      // A company's owners and tax details are loaded separately and laid over its listing.
      const isCompany = ['agency', 'customer'].includes(userTypeOf(currentUser));
      const listingData = isCompany
        ? (await loadCompanyCredentialDetails(response?.data?.data, profileListingId)).listing
        : response?.data?.data;
      dispatch(showProfileListingSuccess(listingData));
      return listingData;
    })
    .catch(e => {
      dispatch(showProfileListingError(storableError(e)));
      throw e;
    });
};

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = (params, search, config) => async (dispatch, getState) => {
  const state = getState();
  const { currentUser } = state.user;


  if (
    currentUser?.attributes?.profile?.publicData?.profileListingId != undefined ||
    currentUser?.attributes?.profile?.publicData?.firstListingId != undefined
  ) {
    await dispatch(showProfileListing());
  }

  return true;
};
